"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountStageNamespace = void 0;
const Environment_1 = require("./Environment");
const getAccountStageNamespace = (k) => `${(0, Environment_1.getProjectPrefix)()}${k}`;
exports.getAccountStageNamespace = getAccountStageNamespace;
